import logger from "loglevel";

const minProdLogLvl = logger.levels.ERROR;
const minDevLogLvl = logger.levels.TRACE;

const logLevel =
  process.env.NODE_ENV === "development" ? minDevLogLvl : minProdLogLvl;

logger.setLevel(logLevel);
